module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAASFBMVEUAAADGxsbGxsbDw8O/v7/GxsbFxcXGxsa/v7/GxsbGxsbExMS/v7+/v7/GxsbFxcXGxsbExMTIyMjIyMjGxsbGxsbIyMjGxsZUJowNAAAAF3RSTlMA9p4fDN3EvwaLdz4YFOdTyzQzKuNPI67/d70AAADZSURBVDjLhVPbFoMgDCPQAuqmm27L///p7uJwnOZNkrYBG1cgk08KaPKTuD1uHlwBHypaOpCxH4JIGPpIostb/nAit0XBk/FQvpeRev5teVaOy1o/Mh1rT8fEy6eHnJjy3nVOjO/jjlrqtz2U3et+4Dq/8kE8jXv6v/SXEjC0BIEQNzG6JiKvzrNvC3r6h2hoCwYmp5WFyoQ6MLcFQpgCc4Rp0rym/VACtJ8aEPtnuRsw/+dnItgL80A2Vs5Y2nXt52q+8rJYwamjhxI9lOiVonZ49/G/Sjm9Ay16DWa53nMQAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/tips-false.png
// module id = rS7o
// module chunks = 1